<!-- 认证用户接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "phone": "18054103169",
                "carNO": "粤K33333",
                "cardPic": "iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAIAAADYYG7QAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAD6SURBVFhH7ZZRDsIwDEN3Wu5/g4FUEUVNmZ0mEkN4X0Ba9fXFaznOmz3HzXhOAaGOyJAMIQOorgz9haHH+3nt1n9Gm6fqiQzZ2hGokQwDLTlss6M6vrbYwkBetF/eQyz5qA6FQc1AexB+Vj9QsXEYKGYI/lLxhIFSGaqgjLnNQDH1WcR9oKlx33ztlyd1McsmkjXkfUxduChl+4UzNC22jEiXGzbU8XL4ZGjDR5zCtmx5Ufgg241WxCoBmbypa5WXfxMo5ub6TwGvjQVi1mPGQDIWiD/3iqdAAghurmWAgJBGGZIhZADVlSEZQgZQXRmSIWQA1ZWhnzP0BG0XxAI+PzZQAAAAAElFTkSuQmCC",
                "credBackUrl": "iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAIAAADYYG7QAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAD6SURBVFhH7ZZRDsIwDEN3Wu5/g4FUEUVNmZ0mEkN4X0Ba9fXFaznOmz3HzXhOAaGOyJAMIQOorgz9haHH+3nt1n9Gm6fqiQzZ2hGokQwDLTlss6M6vrbYwkBetF/eQyz5qA6FQc1AexB+Vj9QsXEYKGYI/lLxhIFSGaqgjLnNQDH1WcR9oKlx33ztlyd1McsmkjXkfUxduChl+4UzNC22jEiXGzbU8XL4ZGjDR5zCtmx5Ufgg241WxCoBmbypa5WXfxMo5ub6TwGvjQVi1mPGQDIWiD/3iqdAAghurmWAgJBGGZIhZADVlSEZQgZQXRmSIWQA1ZWhnzP0BG0XxAI+PzZQAAAAAElFTkSuQmCC",
                "idCardFrontUrl": "iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAIAAADYYG7QAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAD6SURBVFhH7ZZRDsIwDEN3Wu5/g4FUEUVNmZ0mEkN4X0Ba9fXFaznOmz3HzXhOAaGOyJAMIQOorgz9haHH+3nt1n9Gm6fqiQzZ2hGokQwDLTlss6M6vrbYwkBetF/eQyz5qA6FQc1AexB+Vj9QsXEYKGYI/lLxhIFSGaqgjLnNQDH1WcR9oKlx33ztlyd1McsmkjXkfUxduChl+4UzNC22jEiXGzbU8XL4ZGjDR5zCtmx5Ufgg241WxCoBmbypa5WXfxMo5ub6TwGvjQVi1mPGQDIWiD/3iqdAAghurmWAgJBGGZIhZADVlSEZQgZQXRmSIWQA1ZWhnzP0BG0XxAI+PzZQAAAAAElFTkSuQmCC",
                "idCardBackUrl": "iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAIAAADYYG7QAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAD6SURBVFhH7ZZRDsIwDEN3Wu5/g4FUEUVNmZ0mEkN4X0Ba9fXFaznOmz3HzXhOAaGOyJAMIQOorgz9haHH+3nt1n9Gm6fqiQzZ2hGokQwDLTlss6M6vrbYwkBetF/eQyz5qA6FQc1AexB+Vj9QsXEYKGYI/lLxhIFSGaqgjLnNQDH1WcR9oKlx33ztlyd1McsmkjXkfUxduChl+4UzNC22jEiXGzbU8XL4ZGjDR5zCtmx5Ufgg241WxCoBmbypa5WXfxMo5ub6TwGvjQVi1mPGQDIWiD/3iqdAAghurmWAgJBGGZIhZADVlSEZQgZQXRmSIWQA1ZWhnzP0BG0XxAI+PzZQAAAAAElFTkSuQmCC",
                "idCardHandUrl": "iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAIAAADYYG7QAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAD6SURBVFhH7ZZRDsIwDEN3Wu5/g4FUEUVNmZ0mEkN4X0Ba9fXFaznOmz3HzXhOAaGOyJAMIQOorgz9haHH+3nt1n9Gm6fqiQzZ2hGokQwDLTlss6M6vrbYwkBetF/eQyz5qA6FQc1AexB+Vj9QsXEYKGYI/lLxhIFSGaqgjLnNQDH1WcR9oKlx33ztlyd1McsmkjXkfUxduChl+4UzNC22jEiXGzbU8XL4ZGjDR5zCtmx5Ufgg241WxCoBmbypa5WXfxMo5ub6TwGvjQVi1mPGQDIWiD/3iqdAAghurmWAgJBGGZIhZADVlSEZQgZQXRmSIWQA1ZWhnzP0BG0XxAI+PzZQAAAAAElFTkSuQmCC",
                "type": 1,
                "authDate": "20190423112510",
                "authBy": "auto-openydt",
                "authType": 1
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台,认证用户",
                t_url: this.commonUrls.test+"authenticateUser",
                p_url: this.commonUrls.prod+"authenticateUser",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'phone', info2: '否', info3: 'String', info4: '注册用户手机号码。phone和userId二者必填一个' },
                        { info1: 'userId', info2: '否', info3: 'Long', info4: '智慧停车用户ID。phone和userId二者必填一个' },
                        { info1: 'carNO', info2: '是', info3: 'String', info4: '车牌号码' },
                        { info1: 'cardPic', info2: '否', info3: 'String', info4: '行驶证主页图片（图像流文件的Base64编码，支持jpg和png格式）。authType=1时，必填' },
                        { info1: 'credBackUrl', info2: '否', info3: 'String', info4: '行驶证副页图片（图像流文件的Base64编码）。type=1且authType=1时，必填' },
                        { info1: 'idCardFrontUrl', info2: '否', info3: 'String', info4: '身份证正面图片（图像流文件的Base64编码）。type=1且authType=1时，必填' },
                        { info1: 'idCardBackUrl', info2: '否', info3: 'String', info4: '身份证背面图片（图像流文件的Base64编码）。type=1且authType=1时，必填' },
                        { info1: 'idCardHandUrl', info2: '否', info3: 'String', info4: '用户手持身份证正面图片（图像流文件的Base64编码）。type=1且authType=1时，必填' },
                        { info1: 'authDate', info2: '是', info3: 'String', info4: '操作时间，yyyyMMddHHmmss' },
                        { info1: 'authBy', info2: '是', info3: 'String', info4: '操作人' },
                        { info1: 'reason', info2: '否', info3: 'String', info4: '审核不通过原因' },
                        { info1: 'type', info2: '否', info3: 'Integer', info4: '证件认证类型，0行驶证认证 1实名认证。默认0' },
                        { info1: 'authType', info2: '是', info3: 'Integer', info4: '认证状态。0认证不通过 1认证通过' },
                        ]
                },],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [

                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/ydtUser/authenticateUser.vue